import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { Platform, LoadingController } from '@ionic/angular';

import { SlackService } from '../../services/slack-service';
import { Alert } from '../../services/alert';

@Component({
  selector: 'app-setup-slack',
  templateUrl: './setup-slack.page.html',
  styleUrls: ['./setup-slack.page.scss'],
})
export class SetupSlackPage implements OnInit {

  isLoading = true
  isError = false
  eventCode = ''
  channelName = ''

  constructor(
    private platform: Platform,
    private loadingCtrl: LoadingController,
    private alert: Alert,
    private changeRef: ChangeDetectorRef
  ) { }

  async ngOnInit() {
    const eventCode = this.platform.getQueryParam('state')
    this.eventCode = eventCode

    const slackAuthCode = this.platform.getQueryParam('code')

    const loading = await this.loadingCtrl.create()
    loading.present()

    SlackService.submitSlackAuthCode(slackAuthCode, eventCode, (slackChannel: string) => {
      
      this.channelName = slackChannel
      this.isLoading = false
      loading.dismiss()
      this.changeRef.detectChanges();

    }, (errorMsg: string) => {
      loading.dismiss()
      this.isError = true
      this.changeRef.detectChanges();
      this.alert.show('Oops!', errorMsg)
    })
  }

}
